/* @ngInject */
function modalService ($document, $compile, $controller, $http, $rootScope, $q, $templateCache, ModalStackService) {
  var currentModal = null
  return {
    showModal: showModal,
    close: closeCurrentModal,
    refresh: refreshCurrentModal,
    getCurrentModal,
    setCurrentModal,
    showCurrentModal
  }

  // ----------------------------------------------------

  function closeCurrentModal (param) {
    const lastModal = ModalStackService.getLastModalOpened()
    if (lastModal?.type !== 'legacy-modal') {
      return
    }
    lastModal.scope._closeModal(param)
  }

  function destroyCurrentModal () {
    if (currentModal) {
      currentModal.scope._destroyModal()
    }
  }

  function refreshCurrentModal () {
    if (currentModal) {
      currentModal.element.modal('refresh')
    }
  }

  function getCurrentModal () {
    return currentModal
  }

  function setCurrentModal (newCurrentModal) {
    currentModal = newCurrentModal
  }

  function showCurrentModal (hideDimmer) {
    currentModal.element.modal('show')

    if (hideDimmer) {
      const modalDimmer = currentModal.element.parent()
      modalDimmer.css({
        background: 'transparent',
        'backdrop-filter': 'blur(0px)'
      })
    }
  }

  // ----------------------------------------------------

  //  Returns a promise which either resolves upon modal close, or fails
  // because the modal could not be rendered.
  function showModal (options) {
    let closeDeferred = $q.defer()

    //  Get the actual html of the template.
    getTemplate(options)
      .then(function (template) {
        //  Create a new scope for the modal.
        let modalScope
        if (options.scope) {
          modalScope = options.scope
        } else if (options.parentScope) {
          modalScope = options.parentScope.$new()
        } else {
          modalScope = $rootScope.$new()
        }

        // add the custom inputs to the scope
        modalScope.inputs = options.inputs || {}
        // pass data to modal's scope
        if (options.data) {
          for (const key in options.data) {
            modalScope[key] = options.data[key]
          }
        }

        if (!options.templateUrl) {
          // make options available to the scope for the template to work
          modalScope.positive = options.positive
          modalScope.negative = options.negative
          modalScope.title = options.title
          modalScope.text = options.text
          modalScope.icon = options.icon
        }

        modalScope._closeModal = function (param) {
          currentModal.scope.closeDialogParam = param
          if (modalElement) {
            ModalStackService.closeLastOpenedModal()

            modalElement.modal('hide', param)
            setTimeout(function () {
              $('div[class="ui dimmer modals page transition hidden"]').remove()
            }, 1000)
          }

          closeDeferred = null
          // keep the modal element to be destroyed after dialog close
          if (!options.destroyable) {
            modalElement = null
            modalScope = null
          }
          currentModal = null
        }

        // create destroy function only if it need to be destroyed
        modalScope._destroyModal = function (param) {
          if (options.destroyable) {
            setTimeout(function () {
              modalElement.remove()
              modalScope.$destroy()
              modalElement = null
              modalScope = null
            }, 100)
          }
        }

        //  Parse the modal HTML into a DOM element (in template form).
        const modalElementTemplate = angular.element(template)

        //  Compile then link the template element, building the actual element.
        //  Set the $element on the inputs so that it can be injected if required.
        const linkFn = $compile(modalElementTemplate)
        let modalElement = linkFn(modalScope)
        // inputs.$element = modalElement;

        //  Create the controller, explicitly specifying the scope to use.
        const controller = options.controller ? options.controller : 'BasicModalController'
        let modalController
        if (typeof controller === 'function') {
          modalController = $controller(controller, { $scope: modalScope })
        } else {
          modalController = $controller(controller + ' as ctrl', { $scope: modalScope })
        }

        //  Finally, append the modal to the dom.
        if (options.appendElement) {
          // append to custom append element
          options.appendElement.append(modalElement)
        } else {
          // append to body when no custom append element is specified
          $document.find('body').append(modalElement)
        }

        //  We now have a modal object...
        currentModal = {
          controller: modalController,
          scope: modalScope,
          element: modalElement,
          type: 'legacy-modal'
        }

        ModalStackService.registerOpenedModal(currentModal, closeCurrentModal)

        $(modalElement)
          .modal({
            onHide: function ($element) {
              if (closeDeferred) {
                //  Resolve the 'close' promise.
                closeDeferred.resolve(currentModal.scope.closeDialogParam)
              }

              destroyCurrentModal()
            },
            centered: true,
            onApprove: options.onApprove || null,
            closable: options.closable || false,
            observeChanges: !!options.observeChanges,
            autofocus: !!options.autofocus,
            allowMultiple: !!options.allowMultiple,
            keyboardShortcuts: false
          })

        showCurrentModal(options.hideDimmer)
      }, function () {
        // if the template failed
        closeDeferred.reject()
      }) // end getTemplate.then

    return closeDeferred.promise
  }// end showModal

  // ----------------------------------------------------

  function getTemplate (options) {
    const deferred = $q.defer()
    if (!options.templateId) {
      let content = options.html || ''

      if (options.htmlInclude) {
        content = "<div ng-include src=\"'" + options.htmlInclude + "'\"></div>"
      }

      let html
      if (options.basic) {
        html = '<div class="ui basic modal small" style="text-align:center"> <i class="close icon" ng-click="close(false)"></i> <div class="header">{{title}}</div> <div class="image content" ng-show="icon"><div class="image" style="margin:auto"><i style="font-size:4rem" class="{{icon}} icon"></i></div> </div> <div class="description"> <p ng-show="text">{{text}}</p> ' + content + ' </div> <div class="actions"> <div class="ui inverted buttons"> <div class="ui red basic inverted button" ng-click="close(false)" ng-show="negative" style="margin-right:6px"> <i class="remove icon"></i> {{negative}} </div> <div class="ui green basic inverted button" ng-click="close(true)" ng-show="positive"> <i class="checkmark icon"></i> {{positive}} </div> </div> </div> </div>'
      } else {
        html = '<div class="ui modal"> <i class="close icon"></i> <div class="header">' +
                      ' {{title}}' +
                      ' </div>' +
                      ' <div class="image content"> <div class="description"> <p ng-show="text">{{text}}</p>' + content + ' </div> </div> <div class="actions"> <div class="ui black deny button" ng-click="close(false)" ng-show="negative"> {{negative}} </div> <div class="ui positive right labeled icon button" ng-click="close(true)" ng-show="positive"> {{positive}} <i class="checkmark icon"></i> </div> </div> </div>'
      }

      deferred.resolve(html)
    } else {
      // check to see if the template has already been loaded
      const cachedTemplate = $templateCache.get(options.templateId)
      if (cachedTemplate !== undefined) {
        deferred.resolve(cachedTemplate)
      } else { // if not, let's grab the template for the first time
        const url = options.templateUrl || options.templateId

        const tplPromise = $http.get(url).then(function (response) { // eslint-disable-line no-unused-vars
          // compile the response, which will put stuff into the cache
          $compile(response.data)
          // now, fetch from cache
          deferred.resolve($templateCache.get(options.templateId))
        })
      }
    }
    return deferred.promise
  }
} // end modalservice

export { modalService }
